import React from 'react';

const CONTENT = {
  room: {
    badge: 'Room not found',
    title: 'This room is not available to you.',
    body: 'The room may have been deleted, or you may not be a member anymore.',
    action: 'Go to Friends',
  },
  dm: {
    badge: 'Conversation not found',
    title: 'You cannot open this conversation.',
    body: 'Start from your friends list and open a direct message with someone you are connected to.',
    action: 'Open Friends',
  },
  child: {
    badge: 'Child chat unavailable',
    title: 'This child chat route is reserved for a future release.',
    body: 'Parent rooms are available now, but nested child chats are not implemented yet.',
    action: 'Go to Friends',
  },
  route: {
    badge: 'Page not found',
    title: 'There is nothing at this address.',
    body: 'Use the sidebar to jump to a room, a friend, or one of the app sections.',
    action: 'Go to Friends',
  },
};

const ContentNotFound = ({ variant = 'route', onNavigateHome }) => {
  const content = CONTENT[variant] || CONTENT.route;

  return (
    <div className="content-not-found">
      <span className="content-not-found-badge">{content.badge}</span>
      <h2 className="content-not-found-title">{content.title}</h2>
      <p className="content-not-found-copy">{content.body}</p>
      <button className="content-not-found-action" type="button" onClick={onNavigateHome}>
        {content.action}
      </button>
    </div>
  );
};

export default ContentNotFound;
